import { SVGProps } from 'react'

function UserSelfieSecond(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 18a2.625 2.625 0 1 0 0-5.25A2.625 2.625 0 0 0 12 18ZM7.5 23.25a4.5 4.5 0 1 1 9 0h-9Z"
        stroke="#3D96FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 8.25a3 3 0 0 1 3 3v12h-15v-12a3 3 0 0 1 3-3M12 7.5a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75M9 4.5 6.75 2.25M15 4.5l2.25-2.25M12 3.75v-3"
        stroke="#3D96FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

UserSelfieSecond.defaultProps = { role: 'graphics-document' }

export default UserSelfieSecond
